import React from "react";
// import Ourservice from '../Common/our_service'
import Contactus from "../Common/Contactus";

import MainBanner from "./MainBanner";
import { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
function Service_content() {
  const [service, setService] = useState([])
  const navigate = useNavigate()
  const getservice = () => {
    axios.get('https://mindcoadmin.v4masters.com/public/index.php/getservice').then((response) => {
      // console.log(response)
      setService(response.data)
    }).catch((error) => {
      console.log(error);
    })
  }
       
  useEffect(() => {
    getservice()
  }, [])

  return (
    <>
      <div>
        <MainBanner page="SERVICES" />
        <section className="our-service" id="our-service">
          <div className="our-service-section  container">
            <div className="bg-white">
              <div className="d-flex">
                <div className="left-side">
                  <h2 className="heading text-purple">Our Service</h2>
                  <p className="fw-medium text-black">
                    Are you looking for a custom app to solve a your business
                    need?
                  </p>
                  <div className="text-gray">
                    We offer impressive mobile app services to accelerate your
                    business to digital world on every device and platform.
                  </div>
                </div>
              </div>
              <div className="grid-container">
                {service.map((item, index) => {
                  return (
                    <div className="grid-item" key={index}  >
                      <div className="card h-100" onClick={() => {navigate(`/service/${item?.page_id}`);console.log('delete')}}>
                        <div className="card-body">
                          <img className="image2" src={`https://smarto.s3.ap-south-1.amazonaws.com/mindcode/service/${item.image2}`} alt="" />
                          <img className="image1" src={`https://smarto.s3.ap-south-1.amazonaws.com/mindcode/service/${item.image1}`} alt="" />
                          <h5 className="mt-4">
                            {item.service_title}<br />{item.service_title2}
                          </h5>
                        </div>
                      </div>
                    </div>
                  )
                }
                )}

              </div>
            </div>
          </div>
        </section>
      </div>
      <Contactus />
    </>
  );
}

export default Service_content;
